import { DEFAULT_DATA, setSliceGuideModalsData, setSliceGuideModalsInfo } from '../slices/FJSliceGuideModals';
import FJUtil from '../../util/FJUtil.js';
import FJConstant from '../../constants/FJConstant.js';

const FJActionGuide = {
    /**
     * @param {Object} data - The data to be set in the guide modal.
     * @returns {Function} - A function that dispatches the setSliceGuideModalsInfo and setSliceGuideModalsData actions.
     */
    showGuideModalAction: data => {
        return dispatch => {
            dispatch(setSliceGuideModalsInfo(true));
            dispatch(
                setSliceGuideModalsData({
                    ...DEFAULT_DATA,
                    ...data,
                }),
            );
        };
    },

    hideGuideModalAction: () => {
        return dispatch => {
            dispatch(setSliceGuideModalsInfo(false));
            dispatch(setSliceGuideModalsData(DEFAULT_DATA));
        };
    },

    showImageToImageGuideModal: () => {
        return dispatch => {
            if (FJUtil.getAB() === 'B' || FJUtil.isMobile()) {
                return;
            }

            if (!FJUtil.isLogin() || FJUtil.isFreePayment()) {
                let _guideModalIndex = 0;
                const GUID_LIST_DATA = [
                    {
                        setpNumTitle: 'video-remove-bg-step-1',
                        // setpTitle: 'video-remove-bg-step-title-1',
                        setpContent: 'upload-an-image-with-a-clear-subject',
                        skipBtnText: 'skip',
                        nextBtnText: 'next',
                        arrowDirection: 'left',
                        relativeDomPosition: {
                            x: '460',
                            y: '50%',
                        },
                        domId: 'imageToImageInput',
                        isShowDom: true,
                        style: { background: '#fff' },
                        containerStyle: { transform: `translate(0%, -50%)` },
                        type: FJConstant.SMALL_MODAL,
                    },
                    {
                        setpNumTitle: 'video-remove-bg-step-2',
                        // setpTitle: 'video-remove-bg-step-title-2',
                        setpContent: 'choose-from-dozens-of-styles',
                        skipBtnText: 'skip',
                        nextBtnText: 'next',
                        relativeDomPosition: {
                            x: '460',
                            y: '50%',
                        },
                        domId: 'imageToImageList',
                        isShowDom: true,
                        arrowDirection: 'left',
                        style: { background: '#fff', borderRadius: '13px' },
                        containerStyle: { transform: `translate(0%, -50%)` },
                        type: FJConstant.SMALL_MODAL,
                        expandWidth: 14,
                    },
                    {
                        setpNumTitle: 'video-remove-bg-step-3',
                        // setpTitle: 'video-remove-bg-step-title-3',
                        setpContent: 'set-image-count-and-click-generate-button',
                        nextBtnText: 'got-it',
                        relativeDomPosition: {
                            x: '460',
                            y: '52%',
                        },
                        domId: 'imageToImageBtn',
                        isShowDom: true,
                        arrowDirection: 'left',
                        containerStyle: { transform: `translate(0%, -50%)` },
                        type: FJConstant.SMALL_MODAL,
                    },
                ];

                const __skipCallback = () => {
                    dispatch(FJActionGuide.hideGuideModalAction());
                };

                const __nextCallback = () => {
                    _guideModalIndex++;

                    if (_guideModalIndex >= GUID_LIST_DATA.length) {
                        dispatch(FJActionGuide.hideGuideModalAction());
                        _guideModalIndex = 0;
                        return;
                    }
                    dispatch(
                        FJActionGuide.showGuideModalAction({
                            ...GUID_LIST_DATA[_guideModalIndex],
                            skipBtnCallback: __skipCallback,
                            nextBtnCallback: __nextCallback,
                        }),
                    );
                };

                const guideModalShown = localStorage.getItem('imageToImageGuideModalShown');
                if (guideModalShown) {
                    return;
                }
                localStorage.setItem('imageToImageGuideModalShown', 'true');
                dispatch(
                    FJActionGuide.showGuideModalAction({
                        ...GUID_LIST_DATA[_guideModalIndex],
                        skipBtnCallback: __skipCallback,
                        nextBtnCallback: __nextCallback,
                    }),
                );
            }
        };
    },

    showTextToImageGuideModal: () => {
        return dispatch => {
            if (FJUtil.getAB() === 'B' || FJUtil.isMobile()) {
                return;
            }
            if (!FJUtil.isLogin() || FJUtil.isFreePayment()) {
                let _guideModalIndex = 0;
                const GUID_LIST_DATA = [
                    {
                        setpNumTitle: 'video-remove-bg-step-1',
                        // setpTitle: 'video-remove-bg-step-title-1',
                        setpContent: 'enter-a-description-of-the-image-you-want-to-create-and-use-ai-to-optimize-it',
                        skipBtnText: 'skip',
                        nextBtnText: 'next',
                        arrowDirection: 'left',
                        relativeDomPosition: {
                            x: '460',
                            y: '50%',
                        },
                        domId: 'textToImagePrompt',
                        isShowDom: true,
                        style: { background: '#fff', borderRadius: '10px' },
                        containerStyle: { transform: `translate(0%, -50%)` },
                        type: FJConstant.SMALL_MODAL,
                        expandWidth: 14,
                    },
                    {
                        setpNumTitle: 'video-remove-bg-step-2',
                        // setpTitle: 'video-remove-bg-step-title-2',
                        setpContent: 'choose-a-style-or-select-none-to-let-the-prompt-decide',
                        skipBtnText: 'skip',
                        nextBtnText: 'next',
                        relativeDomPosition: {
                            x: '460',
                            y: '50%',
                        },
                        domId: 'textToImageStyle',
                        isShowDom: true,
                        arrowDirection: 'left',
                        style: { background: '#fff', borderRadius: '10px' },
                        containerStyle: { transform: `translate(0%, -50%)` },
                        type: FJConstant.SMALL_MODAL,
                        expandWidth: 14,
                    },
                    {
                        setpNumTitle: 'video-remove-bg-step-3',
                        // setpTitle: 'video-remove-bg-step-title-3',
                        setpContent: 'set-the-model-for-quality-ratio-and-image-count-then-start-generating',
                        nextBtnText: 'got-it',
                        relativeDomPosition: {
                            x: '460',
                            y: '52%',
                        },
                        domId: 'textToImageBtn',
                        isShowDom: true,
                        arrowDirection: 'left',
                        containerStyle: { transform: `translate(0%, -50%)` },
                        type: FJConstant.SMALL_MODAL,
                    },
                ];

                const __skipCallback = () => {
                    dispatch(FJActionGuide.hideGuideModalAction());
                };

                const __nextCallback = () => {
                    _guideModalIndex++;

                    if (_guideModalIndex >= GUID_LIST_DATA.length) {
                        dispatch(FJActionGuide.hideGuideModalAction());
                        _guideModalIndex = 0;
                        return;
                    }
                    dispatch(
                        FJActionGuide.showGuideModalAction({
                            ...GUID_LIST_DATA[_guideModalIndex],
                            skipBtnCallback: __skipCallback,
                            nextBtnCallback: __nextCallback,
                        }),
                    );
                };

                const guideModalShown = localStorage.getItem('textToImageGuideModalShown');
                if (guideModalShown) {
                    return;
                }
                localStorage.setItem('textToImageGuideModalShown', 'true');
                dispatch(
                    FJActionGuide.showGuideModalAction({
                        ...GUID_LIST_DATA[_guideModalIndex],
                        skipBtnCallback: __skipCallback,
                        nextBtnCallback: __nextCallback,
                    }),
                );
            }
        };
    },
};

export default FJActionGuide;
